import { render } from "./Header.vue?vue&type=template&id=4a520e9a&scoped=true&bindings={\"dropdownOpen\":\"data\"}"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=4a520e9a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4a520e9a"

export default script